// Shared constants + helpers for the Regulatory Framework Engine UI.

export const RISK_TONE = {
  critical: { color: "#991B1B", bg: "#FEE2E2", label: "Critical" },
  high:     { color: "#B45309", bg: "#FEF3C7", label: "High" },
  medium:   { color: "#1E40AF", bg: "#DBEAFE", label: "Medium" },
  low:      { color: "#065F46", bg: "#D1FAE5", label: "Low" },
};

export const STATUS_TONE = {
  compliant:     { color: "#065F46", bg: "#D1FAE5", label: "Compliant" },
  partial:       { color: "#B45309", bg: "#FEF3C7", label: "Partial" },
  non_compliant: { color: "#991B1B", bg: "#FEE2E2", label: "Non-Compliant" },
  not_assessed:  { color: "#334155", bg: "#F1F5F9", label: "Not Assessed" },
  not_applicable:{ color: "#64748B", bg: "#F8FAFC", label: "N/A" },
};

export const READINESS_TONE = {
  ready:        { color: "#065F46", bg: "#D1FAE5" },
  substantial:  { color: "#065F46", bg: "#ECFDF5" },
  partial:      { color: "#B45309", bg: "#FEF3C7" },
  initial:      { color: "#991B1B", bg: "#FEE2E2" },
  not_assessed: { color: "#334155", bg: "#F1F5F9" },
};

export const READINESS_LABEL = {
  ready: "Ready", substantial: "Substantial", partial: "Partial",
  initial: "Initial", not_assessed: "Not Assessed",
};

export const FRAMEWORK_META = {
  hipaa:        { color: "#0F766E", accent: "#14B8A6", label: "HIPAA" },
  cfr42_part2:  { color: "#7C3AED", accent: "#A78BFA", label: "42 CFR Part 2" },
  soc2:         { color: "#1E40AF", accent: "#3B82F6", label: "SOC 2" },
  nist_csf:     { color: "#B45309", accent: "#F59E0B", label: "NIST CSF" },
};

export function fmtDate(iso) {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleDateString(undefined, { dateStyle: "medium" }); }
  catch { return iso; }
}
